@if (table.ready$ | async) {
  <table mat-table [dataSource]="table.items$" [trackBy]="tableService.trackEntity" matSort (matSortChange)="tableService.handleMatSortChange(table, $event)">
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ table.columns.name.name }}</th>
      <td mat-cell *matCellDef="let apiToken">{{ apiToken.name }}</td>
    </ng-container>
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ table.columns.id.name }}</th>
      <td mat-cell *matCellDef="let apiToken"><tp-table-copyable-text-cell [text]="apiToken.id"/></td>
    </ng-container>
    <ng-container matColumnDef="space">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ table.columns.space.name }}</th>
      <td mat-cell *matCellDef="let apiToken">{{ apiToken.spaceId }}</td>
    </ng-container>
    <ng-container matColumnDef="accessLevel">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ table.columns.accessLevel.name }}</th>
      <td mat-cell *matCellDef="let apiToken">{{ apiToken.accessLevel | accessLevel }}</td>
    </ng-container>
    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ table.columns.createdAt.name }}</th>
      <td mat-cell *matCellDef="let apiToken">{{ apiToken.createdAt | datetime }}</td>
    </ng-container>
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let apiToken">
        <button
          mat-fab aria-label="more" [disabled]="!rowPopupMenuItems!(apiToken).length"
          [matMenuTriggerFor]="rowPopupMenu" [matMenuTriggerData]="{ items: rowPopupMenuItems!(apiToken) }"
          (click)="$event.stopPropagation()"
        >
          <i class="fa-light fa-ellipsis"></i>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="table.displayedColumns"></tr>
    <tr mat-row *matRowDef="let apiToken; columns: table.displayedColumns"></tr>
  </table>
} @else {
  <tp-spinner/>
}

<mat-menu #rowPopupMenu="matMenu">
  <ng-template matMenuContent let-items="items">
    @for (item of items; track item) {
      <button mat-menu-item (click)="item.action()" [class]="item.dangerous ? 'dangerous' : ''">{{ item.label }}</button>
    }
  </ng-template>
</mat-menu>
